import React, {useCallback} from 'react';
import {classes} from './HeaderLoader.st.css';
import {useExperiments} from '@wix/yoshi-flow-editor';
import {SPECS} from '../../../constants';

export const HeaderLoader = () => {
  const {experiments} = useExperiments();

  const isPageHierarchyAccessible = experiments.enabled(SPECS.AccessibilityOptimizedPageHierarchy);

  const HeaderComponent = useCallback<React.FC<React.HTMLAttributes<HTMLElement>>>(
    (props) => (isPageHierarchyAccessible ? <div {...props} /> : <header {...props} />),
    [isPageHierarchyAccessible]
  );

  return (
    <HeaderComponent className={classes.header}>
      <div className={classes.frame}>
        <div
          key={'header-main'}
          className={
            experiments.enabled(SPECS.FixCheckoutHeaderCSS) ? classes.main : /* istanbul ignore next */ classes.mainOld
          }
        />
      </div>
      <div className={classes.divider} />
    </HeaderComponent>
  );
};
